module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0wIDE4SDNWMTVIME01IDE4SDhWMTFINU0xMCAxOEgxM1Y2SDEwTTE1IDE4SDE4VjBIMTVWMThaIiBmaWxsPSIjMjBFQjBEIi8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/sign.svg
// module id = klQw
// module chunks = 1